var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000128450107367881300510000010160294360933135016_);}\n\t.st1{clip-path:url(#SVGID_00000130609121534082359200000004232039589925074333_);}\n\t.st2{clip-path:url(#SVGID_00000001647515381264104130000000083354753316852920_);enable-background:new    ;}\n\t.st3{clip-path:url(#SVGID_00000031168745080845969580000014523394315345955260_);}\n\t.st4{clip-path:url(#SVGID_00000157274260474787945910000017452399342523781048_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M138.4,25.4l0.1,24.3l24.6,0.4L138.4,25.4z M49.1,43.4l-12.8,0v135.2h108.5V166h22.3l0,0H49.1L49.1,43.4z  M138.3,12l38.4,38.3v116.2l-22.3-0.4v22H26.8V34h22.3l0-22H138.3z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#1E1E1E"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132062002164027239610000002746735769391168407_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132062002164027239610000002746735769391168407_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039094688421772634150000003982527157059214736_",
    x: -1929.3,
    y: -11893.9,
    width: 2347.3,
    height: 12362.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058551183071641974310000014772195177792490120_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039094688421772634150000003982527157059214736_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021803280518256566450000008349284389776293546_",
    points: "150.5,85.8 128.4,108 149.2,128.8 134.9,143.2  114,122.3 93.2,143.2 78.8,128.8 99.7,108 77.5,85.8 91.9,71.5 114,93.6 136.2,71.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172403069033904634030000016816154285229650589_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021803280518256566450000008349284389776293546_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000172403069033904634030000016816154285229650589_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000002368081338319767180000011691451804124745111_",
    x: -1929.3,
    y: -11893.9,
    width: 2347.3,
    height: 12362.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113351052029677570600000009766240111347939514_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002368081338319767180000011691451804124745111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000113351052029677570600000009766240111347939514_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000057838378309410967820000012618195815008942518_",
    x: 65.9,
    y: 64.1,
    width: 91.3,
    height: 91.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132070593484792670150000015571857291447659952_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057838378309410967820000012618195815008942518_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132070593484792670150000015571857291447659952_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000112596820536600870210000005476671934918525608_",
    x: 72.4,
    y: 70.7,
    width: 78.2,
    height: 78.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036962198892977815380000007222411683845977006_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112596820536600870210000005476671934918525608_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 65.9,
    y: 64.1,
    style: {
      clipPath: "url(#SVGID_00000036962198892977815380000007222411683845977006_)",
      fill: "#FFFFFF"
    },
    width: 91.3,
    height: 91.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.02ba8eeed258c8e9062d60af48adea41.svg";
export { ForwardRef as ReactComponent };